import script from "./LandingPageSection.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingPageSection.vue?vue&type=script&setup=true&lang=js"

import "./LandingPageSection.vue?vue&type=style&index=0&id=cf55ecac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf55ecac"]])

export default __exports__